import {localAxiosRequest} from "@/utils/axios";
const ORDERS_BASE_URL = '/orders';

/**
 * 提交订单
 */
const submitOrder = function (param){
    return localAxiosRequest({
        method: 'POST',
        url: `${ORDERS_BASE_URL}/submit_order`,
        data: param
    }, false, true);
};

/**
 * 根据订单号获取订单
 */
const getOrderById = function (orderId){
    return localAxiosRequest({
        method: 'GET',
        url: `${ORDERS_BASE_URL}/${orderId}/get_order`,
    });
};

export { submitOrder, getOrderById };
